import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Content from '../../../layout/Content'
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes'
import DriverForSchedulingSearchForm from './DriverForSchedulingSearchForm'
import Table from '../../../common/Table'
import { DRIVER_FOR_SCHEDULING_COLUMNS } from '../../../../config/columns'
import { tzNormalizeDate } from '../../../../utils/date'
import { INT_DATE_FORMAT } from '../../../../config/locale'
import { clearDriverForScheduling, getDriverForScheduling } from '../../../../actions/traffic/DriverForScheduling'

const DriverForScheduling = ({ breadcrumbs, itineraries, loading, dispatchGetDriverForScheduling, dispatchClearDriverForScheduling }) => {

  useEffect(() => () => {
    dispatchClearDriverForScheduling()
  }, []);

  const handleSearchSubmit = (formValues) => {
    const newFormValues = {
      fromDateString: tzNormalizeDate({ date: formValues.fromDateString, format: INT_DATE_FORMAT }),
      toDateString: tzNormalizeDate({ date: formValues.toDateString, format: INT_DATE_FORMAT }),
      itineraryDirection: formValues.direction ? formValues.direction.value : null,
      homeBaseLocationId: formValues.homeBaseLocation ? formValues.homeBaseLocation.value : null,
      showNorteChico: formValues.showNorteChico,
    }

    const { serviceTypes } = formValues;

    if (serviceTypes) {
      newFormValues.serviceTypes = serviceTypes.map(st => st.value);
    }

    dispatchGetDriverForScheduling(newFormValues)
  }

  const defaultFilterMethod = (filter, row) => {
    const id = filter.pivotId || filter.id;
    const value = row[id];

    if (value == null) return false;

    return String(value)
      .toLowerCase()
      .includes(String(filter.value).toLowerCase());
  };

  const content = (
    <>
      <DriverForSchedulingSearchForm onSubmit={handleSearchSubmit} loading={loading} />
      <Table
        data={itineraries || []}
        columns={DRIVER_FOR_SCHEDULING_COLUMNS}
        loading={loading}
        manual={false}
        filterable
        defaultFilterMethod={defaultFilterMethod}
      />
    </>
  )

  return (
    <Content
      title="Programación de Conductores"
      content={content}
      breadcrumbs={breadcrumbs}
    />
  )
}

DriverForScheduling.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  itineraries: PropTypes.arrayOf(PropTypes.shape({
    departureDate: PropTypes.number,
    sourceLocationName: PropTypes.string,
    destinationLocationName: PropTypes.string,
    serviceTypeName: PropTypes.string,
    companyBusId: PropTypes.string,
    registeredBusHomeBaseName: PropTypes.string,
    driverOneName: PropTypes.string,
    driverTwoName: PropTypes.string,
    driverThreeName: PropTypes.string,
    itineraryDirection: PropTypes.string,
    routeName: PropTypes.string,
    itineraryId: PropTypes.number,
  })).isRequired,
  loading: PropTypes.bool.isRequired,
  dispatchGetDriverForScheduling: PropTypes.func.isRequired,
  dispatchClearDriverForScheduling: PropTypes.func.isRequired,
}

const mapStateToProps = ({ TrafficUnit }) => ({
  breadcrumbs: [
    ...TrafficUnit.DriverUnitHome.get('breadcrumbs'),
    {
      text: 'Programación de Conductores',
      href: '',
    },
  ],
  itineraries: TrafficUnit.DriverForScheduling.getIn(['all', 'content', 'content']),
  loading: TrafficUnit.DriverForScheduling.getIn(['all', 'loading']),
})

const mapDispatchToProps = {
  dispatchGetDriverForScheduling: getDriverForScheduling,
  dispatchClearDriverForScheduling: clearDriverForScheduling,
}

export default connect(mapStateToProps, mapDispatchToProps)(DriverForScheduling)
